import React from 'react';

/**
 * BurrowLogo — pixel-faithful SVG recreation using filled paths (no stroke),
 * so nothing can be clipped at the edges.
 * props:
 *   height — total height in px (default 28)
 */
export default function BurrowLogo({ height = 28 }) {
  const fontSize = Math.round(height * 0.85);

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        userSelect: 'none',
        textDecoration: 'none',
      }}
    >
      {/*
        Arrow icon — fully filled paths, zero stroke.
        ViewBox 0 0 100 90 with generous internal margin so
        nothing sits near an edge that could get clipped.

        Shape breakdown (all filled #ff4500):
          1. Arrow body — a thick filled polygon tracing both sides
             of the zigzag trend line.
          2. Arrowhead — a triangle at the top-right tip.
      */}
      <svg
        height={height}
        viewBox="0 0 100 90"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/*
          Body polygon (traces the "thick line" as a filled shape):
            top-left  → first peak → dip valley → shoot up-right
            then back along the bottom edge
        */}
        <path
          d={`
            M 10 75
            L 10 63
            L 30 32
            L 42 44
            L 62 12
            L 72 22
            L 50 54
            L 38 42
            L 22 73
            Z
          `}
          fill="#ff4500"
        />
        {/* Arrowhead triangle — tip at top-right */}
        <polygon
          points="62,12 88,6 80,32"
          fill="#ff4500"
        />
      </svg>

      {/* Wordmark */}
      <span
        style={{
          fontFamily: "'Jost', sans-serif",
          fontWeight: 700,
          fontSize: fontSize,
          color: '#ffffff',
          letterSpacing: '-0.02em',
          lineHeight: 1,
        }}
      >
        burrow
      </span>
    </span>
  );
}
